import React, { useState } from 'react';
import axios from 'axios';
import Header from '../../components/Header';
import Link from '../../components/Link';
import PageTitle from '../../components/PageTitle';
import styles from '../styles/estoques/Conferencia.module.css';
import NotificacaoSucesso from '../../components/NotificacaoSucesso';
import NotificacaoErro from '../../components/NotificacaoErro';
import ModalConfirmacao from '../../components/ModalConfirmacao';
import useEmpresas from '../../controllers/nomesEmpresas';

function ConferenciaEstoques() {
    const token = localStorage.getItem("token");
    const usuario = localStorage.getItem("usuario");
    const permissoes = JSON.parse(localStorage.getItem('permissoes'));

    const { empresas } = useEmpresas();

    const [empresaSelecionada, setEmpresaSelecionada] = useState("");

    const [code, setCode] = useState("");
    const [products, setProducts] = useState([]);

    const [mensagemNotificacao, setMensagemNotificacao] = useState('');
    const [notificacaoSucesso, setNotificacaoSucesso] = useState(false);
    const [notificacaoErro, setNotificacaoErro] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [onConfirmAction, setOnConfirmAction] = useState(null);

    const [resumo, setResumo] = useState('');

    const [isFiltered, setIsFiltered] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');

    // Função para filtrar produtos pelo código
    const filteredProducts = products.filter((product) =>
        product.code.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Função para ativar o filtro
    const applyFilter = () => {
        const filteredData = products.filter(
            item => item.quantity !== item.qtd_total
        );
        setProducts(filteredData);
        setIsFiltered(true);
    };

    // Buscar produtos
    const fetchProductsByEmpresa = async (empresa) => {
        if (empresa) {
            try {
                const response = await axios.get(`http://provin.ind.br/api/estoques/conferencia/buscarProdutos`, {
                    params: {
                        empresa,
                        usuario,
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setProducts(response.data.map((item) => ({
                    code: item.codigo,
                    description: item.descricao,
                    quantity: item.qtd,
                    qtd_em_terc: item.qtd_em_terc || 0,
                    qtd_disponivel: item.qtd_disponivel || 0,
                    qtd_total: item.qtd_total || 0,
                    date: item.data,
                    imagePath: `/images/produtos/${item.codigo}.jpg`,
                })));
            } catch (error) {
                console.error("Erro ao buscar produtos:", error);
                alert("Erro ao buscar produtos.");
            }
        }
    };

    // Função para desativar o filtro
    const cancelFilter = () => {
        setIsFiltered(false);
        fetchProductsByEmpresa(empresaSelecionada);
    };

    // Verificar e adicionar produto
    const fetchProduct = async (productCode) => {
        if (!empresaSelecionada) {
            alert("Por favor, selecione uma empresa.");
            return null;
        }

        try {
            const response = await axios.post(`https://provin.ind.br/api/estoques/conferencia/adicionarProduto`, {
                codigo: productCode,
                empresa: empresaSelecionada,
                usuario,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.exists) {
                return {
                    code: productCode,
                    description: response.data.descricao,
                    imagePath: `/images/produtos/${productCode}.jpg`,
                    quantity: 1,
                };
            } else {
                alert("Código do produto não encontrado!");
                return null;
            }
        } catch (error) {
            console.error("Erro ao verificar o produto:", error);
            alert("Erro ao verificar o produto.");
            return null;
        }
    };

    const handleAddProduct = async () => {
        if (code) {
            const existingProduct = products.find((product) => product.code === code);

            if (existingProduct) {
                // Se o produto já existe, aumenta a quantidade
                setProducts(
                    products.map((product) =>
                        product.code === code
                            ? { ...product, quantity: product.quantity + 1 }
                            : product
                    )
                );

                await fetchProduct(code);
            } else {
                // Faz a verificação do produto no backend
                const newProduct = await fetchProduct(code);

                if (newProduct) {
                    // Adiciona o novo produto
                    setProducts([newProduct, ...products]);
                }
            }
            setCode(""); // Limpa o campo de entrada após adicionar

            setIsFiltered(false);
            await fetchProductsByEmpresa(empresaSelecionada);
        }
    };

    // Atualizar quantidade
    const handleUpdateQuantity = async (productCode, newQuantity) => {
        try {
            await axios.put(`https://provin.ind.br/api/estoques/conferencia/atualizarQuantidade`, {
                codigo: productCode,
                empresa: empresaSelecionada,
                usuario,
                quantidade: newQuantity
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setProducts(
                products.map((product) =>
                    product.code === productCode ? { ...product, quantity: newQuantity } : product
                )
            );

            setIsFiltered(false);
            await fetchProductsByEmpresa(empresaSelecionada);

            setMensagemNotificacao("Quantidade atualizada!");
            setNotificacaoSucesso(true);
            setTimeout(() => {
                setNotificacaoSucesso(false);
            }, 1000); // A mensagem desaparecerá após 1 segundo
        } catch (error) {
            console.error("Erro ao atualizar a quantidade:", error);
            alert("Erro ao atualizar a quantidade.");
        }
    };

    // Função para abrir o modal de confirmação para remover um item específico
    const confirmarRemoverItem = (codigo) => {
        setModalMessage('Tem certeza que deseja remover este item?');
        setOnConfirmAction(() => () => handleRemoveProduct(codigo)); // Define a função com o código específico
        setIsModalOpen(true); // Abre o modal
    };

    // Deletar um produto
    const handleRemoveProduct = async (productCode) => {
        setIsModalOpen(false); // Fecha o modal

        try {
            await axios.delete(`https://provin.ind.br/api/estoques/conferencia/deletarProduto`, {
                data: {
                    codigo: productCode,
                    empresa: empresaSelecionada,
                    usuario,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setProducts(products.filter((product) => product.code !== productCode));

            setMensagemNotificacao("Produto removido da contagem!");
            setNotificacaoErro(true);
            setTimeout(() => {
                setNotificacaoErro(false);
            }, 3000); // A mensagem desaparecerá após 3 segundos
        } catch (error) {
            console.error("Erro ao remover o produto:", error);
            alert("Erro ao remover o produto.");
        }
    };

    // Função de confirmação do modal
    const confirmarDeletarProdutos = () => {
        setModalMessage('Tem certeza que deseja excluir a sua contagem?');
        setOnConfirmAction(() => handleDeleteAll);
        setIsModalOpen(true); // Abre o modal
    };

    // Deletar todos os produtos da contagem
    const handleDeleteAll = async () => {
        setIsModalOpen(false); // Fecha o modal

        if (!empresaSelecionada) {
            alert("Por favor, selecione uma empresa.");
            return;
        }

        try {
            await axios.delete(`https://provin.ind.br/api/estoques/conferencia/deletarTodosProdutos`, {
                data: {
                    empresa: empresaSelecionada,
                    usuario,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // Limpa a lista de produtos após deletar
            setProducts([]);

            setMensagemNotificacao("Contagem excluída!");
            setNotificacaoErro(true);
            setTimeout(() => {
                setNotificacaoErro(false);
            }, 3000); // A mensagem desaparecerá após 3 segundos
        } catch (error) {
            console.error("Erro ao excluir conferência:", error);
            alert("Erro ao excluir a conferência.");
        }
    };

    // Função para conferir o estoque
    const handleConferirEstoque = async () => {
        if (!empresaSelecionada) {
            alert("Por favor, selecione uma empresa.");
            return;
        }

        try {
            const response = await axios.post(`https://provin.ind.br/api/estoques/conferencia/conferirEstoque`, {
                empresa: empresaSelecionada,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'json',
            });

            const { file, resumo } = response.data;

            // Baixar a planilha
            const link = document.createElement('a');
            link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${file}`;
            link.download = `Conferencia_Estoque_${empresaSelecionada}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Mostrar o resumo
            setResumo(resumo);

        } catch (error) {
            console.error("Erro ao conferir estoque:", error);
            alert("Erro ao conferir o estoque.");
        }
    };

    return (
        <div className={styles.body}>
            <Header />

            <Link redirectTo="/estoques" />

            <PageTitle src="/images/common/leitor.png" title="Conferência de Estoque" />

            <div className={styles.container}>
                <div className={styles.containerTabela}>
                    {/* Empresa */}
                    <div className={styles.selectEmpresa}>
                        <p>Empresa</p>
                        <select value={empresaSelecionada} onChange={(e) => {
                            const empresa = e.target.value;
                            setEmpresaSelecionada(empresa);
                            fetchProductsByEmpresa(empresa);
                        }}>
                            <option value="">Selecione...</option>
                            {permissoes.produtos.empresas_permitidas.map((codigo, index) => (
                                <option key={index} value={codigo}>
                                    {empresas[codigo] ? `${codigo} - ${empresas[codigo]}` : codigo}
                                </option>
                            ))}
                        </select>

                        <button onClick={handleConferirEstoque}>Conferir Estoque</button>
                        <button onClick={confirmarDeletarProdutos}>Excluir Conferência</button>
                    </div>

                    {/* Resumo */}
                    {resumo && (
                        <div className={styles.resultadoConferencia}>
                            <h1>Resultado da Conferência</h1>

                            <hr />

                            <ul>
                                <p>OK</p>
                                <li>{resumo.iguais} códigos</li>
                                <br />
                                <p>DIVERGÊNCIAS</p>
                                <li><span>Quantidade Inferior: </span>{resumo.maisEmEstoque} códigos (faltou bipar)</li>
                                <li><span>Quantidade Superior: </span>{resumo.maisNoConferencia} códigos (bipou a mais)</li>
                            </ul>
                        </div>
                    )}

                    {/* Campo de entrada para o código de barras */}
                    <div className={styles.inputCodigoBarras}>
                        <input
                            type="text"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === "Enter") handleAddProduct();
                            }}
                            placeholder="Escaneie o código de barras"
                        />
                    </div>

                    <div className={styles.filters}>
                        <div>
                            <button onClick={cancelFilter} className={`${!isFiltered ? styles.active : ''}`}>Todos Produtos</button>
                            <button onClick={applyFilter} className={`${isFiltered ? styles.active : ''}`}>Apenas Divergências</button>
                        </div>

                        <div>
                            <input
                                type="text"
                                placeholder="Pesquisar código..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                            <p><span>Total:</span> {filteredProducts.length} códigos</p>
                        </div>
                    </div>

                    {/* Tabela para mostrar produtos escaneados */}
                    <table>
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Descrição</th>
                                <th>Contagem</th>
                                <th>Em Condicional</th>
                                <th>Em Casa</th>
                                <th>Estoque Total</th>
                                <th>Imagem</th>
                                <th>Ações</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredProducts.length === 0 ? (
                                <tr>
                                    <td colSpan={8} style={{ textAlign: 'center' }}>
                                        Nenhum produto a exibir
                                    </td>
                                </tr>
                            ) : (
                                filteredProducts.map((product) => (
                                    <tr key={product.code}>

                                        <td>{product.code}</td>

                                        <td>{product.description}</td>

                                        <td className={styles.inputQtd}>
                                            <input
                                                type="number"
                                                value={product.quantity}
                                                min="1"
                                                onChange={(e) => {
                                                    const newQuantity = parseInt(e.target.value);
                                                    handleUpdateQuantity(product.code, newQuantity);
                                                }}
                                            />
                                        </td>

                                        <td>{product.qtd_em_terc}</td>

                                        <td>{product.qtd_disponivel}</td>

                                        <td>{product.qtd_total}</td>

                                        <td className={styles.td_com_imagem}>
                                            <img
                                                src={product.imagePath}
                                                alt={product.code}
                                                onError={(e) => e.target.src = "/images/common/sem_imagem.jpg"}
                                            />
                                        </td>

                                        <td className={styles.botaoRemoverItem}>
                                            <button onClick={() => confirmarRemoverItem(product.code)}>
                                                <img
                                                    src="/images/common/x.svg"
                                                    alt="Remover"
                                                    width="30"
                                                    height="30"
                                                />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <NotificacaoSucesso
                message={mensagemNotificacao}
                show={notificacaoSucesso}
            />

            <NotificacaoErro
                message={mensagemNotificacao}
                show={notificacaoErro}
            />

            <ModalConfirmacao
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={onConfirmAction}
                message={modalMessage}
            />
        </div>
    );
}

export default ConferenciaEstoques;